export default {
    topics: [
        {
            title: ' Cleanup ',
            href: 'sm-workflow-Cleanup.html',
            attributes: { 'data-id': 'sm-workflow-Cleanup' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Cleanup-d66e1753',
            topics: [],
        },
        {
            title: ' DeleteResult ',
            href: 'sm-workflow-DeleteResult.html',
            attributes: { 'data-id': 'sm-workflow-DeleteResult' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-DeleteResult-d66e1761',
            topics: [],
        },
        {
            title: ' Execute ',
            href: 'sm-workflow-Execute.html',
            attributes: { 'data-id': 'sm-workflow-Execute' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Execute-d66e1769',
            topics: [],
        },
        {
            title: ' ExecuteInstance ',
            href: 'sm-workflow-ExecuteInstance.html',
            attributes: { 'data-id': 'sm-workflow-ExecuteInstance' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-ExecuteInstance-d66e1777',
            topics: [],
        },
        {
            title: ' GetLogin ',
            href: 'sm-workflow-GetLogin.html',
            attributes: { 'data-id': 'sm-workflow-GetLogin' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-GetLogin-d66e1785',
            topics: [],
        },
        {
            title: ' GetValidationParameters ',
            href: 'sm-workflow-GetValidationParameters.html',
            attributes: { 'data-id': 'sm-workflow-GetValidationParameters' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-GetValidationParameters-d66e1793',
            topics: [],
        },
        {
            title: ' Kill ',
            href: 'sm-workflow-Kill.html',
            attributes: { 'data-id': 'sm-workflow-Kill' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Kill-d66e1801',
            topics: [],
        },
        {
            title: ' Pause ',
            href: 'sm-workflow-Pause.html',
            attributes: { 'data-id': 'sm-workflow-Pause' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Pause-d66e1809',
            topics: [],
        },
        {
            title: ' PostEvent ',
            href: 'sm-workflow-PostEvent.html',
            attributes: { 'data-id': 'sm-workflow-PostEvent' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-PostEvent-d66e1817',
            topics: [],
        },
        {
            title: ' Reply ',
            href: 'sm-workflow-Reply.html',
            attributes: { 'data-id': 'sm-workflow-Reply' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Reply-d66e1825',
            topics: [],
        },
        {
            title: ' Restart ',
            href: 'sm-workflow-Restart.html',
            attributes: { 'data-id': 'sm-workflow-Restart' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Restart-d66e1834',
            topics: [],
        },
        {
            title: ' RestartTask ',
            href: 'sm-workflow-RestartTask.html',
            attributes: { 'data-id': 'sm-workflow-RestartTask' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-RestartTask-d66e1842',
            topics: [],
        },
        {
            title: ' SetLogin ',
            href: 'sm-workflow-SetLogin.html',
            attributes: { 'data-id': 'sm-workflow-SetLogin' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-SetLogin-d66e1850',
            topics: [],
        },
        {
            title: ' Simulate ',
            href: 'sm-workflow-Simulate.html',
            attributes: { 'data-id': 'sm-workflow-Simulate' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Simulate-d66e1858',
            topics: [],
        },
        {
            title: ' SimulateWithParameters ',
            href: 'sm-workflow-SimulateWithParameters.html',
            attributes: { 'data-id': 'sm-workflow-SimulateWithParameters' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-SimulateWithParameters-d66e1866',
            topics: [],
        },
        {
            title: ' Spawn ',
            href: 'sm-workflow-Spawn.html',
            attributes: { 'data-id': 'sm-workflow-Spawn' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Spawn-d66e1874',
            topics: [],
        },
        {
            title: ' SpawnWithParameters ',
            href: 'sm-workflow-SpawnWithParameters.html',
            attributes: { 'data-id': 'sm-workflow-SpawnWithParameters' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-SpawnWithParameters-d66e1882',
            topics: [],
        },
        {
            title: ' SpawnWithParametersEx ',
            href: 'sm-workflow-SpawnWithParametersEx.html',
            attributes: { 'data-id': 'sm-workflow-SpawnWithParametersEx' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-SpawnWithParametersEx-d66e1890',
            topics: [],
        },
        {
            title: ' Start ',
            href: 'sm-workflow-Start.html',
            attributes: { 'data-id': 'sm-workflow-Start' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Start-d66e1898',
            topics: [],
        },
        {
            title: ' StartWithParameters ',
            href: 'sm-workflow-StartWithParameters.html',
            attributes: { 'data-id': 'sm-workflow-StartWithParameters' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-StartWithParameters-d66e1906',
            topics: [],
        },
        {
            title: ' Stop ',
            href: 'sm-workflow-Stop.html',
            attributes: { 'data-id': 'sm-workflow-Stop' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Stop-d66e1914',
            topics: [],
        },
        {
            title: ' Wakeup ',
            href: 'sm-workflow-Wakeup.html',
            attributes: { 'data-id': 'sm-workflow-Wakeup' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-Wakeup-d66e1923',
            topics: [],
        },
        {
            title: ' WakeupTask ',
            href: 'sm-workflow-WakeupTask.html',
            attributes: { 'data-id': 'sm-workflow-WakeupTask' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-WakeupTask-d66e1931',
            topics: [],
        },
    ],
};

